<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">投诉详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->
      <zj-layout-main>
        <el-form ref="form" :model="data" :rules="rules" label-width="16rem" style="width: 80%">
          <el-row>
            <el-col :span="12">
              <el-form-item label="投诉人" prop="ComplainUser">
                <el-input v-model="data.ComplainUser" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话" prop="ContactTel">
                <el-input v-model="data.ContactTel" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="投诉来源" prop="ComplaintSource">
                <el-select
                  v-model="data.ComplaintSource"
                  placeholder="请选择"
                  :disabled="!IsEdit"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in ComplaintSourceArr"
                    :key="item.ItemValue"
                    :label="item.Description"
                    :value="item.ItemValue"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="投诉对象" prop="BeComplained">
                <el-input v-model="data.BeComplained" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="投诉时间" prop="ComplaintTime">
                <el-date-picker
                  type="datetime"
                  style="width: 100%"
                  placeholder="选择日期"
                  v-model="data.ComplaintTime"
                  v-bind:disabled="!IsEdit"
                  format="yyyy-MM-dd HH:mm"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="投诉地点" prop="ComplaintPlace">
                <el-input v-model="data.ComplaintPlace" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="投诉部门" prop="ComplaintDepartmentId">
                <el-select
                  v-model="data.ComplaintDepartmentId"
                  :disabled="!IsEdit"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in ComplaintDepartments"
                    :key="item.OrgId"
                    :label="item.OrgName"
                    :value="item.OrgId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="投诉状态" prop="ComplaintStatus">
                <el-select
                  v-model="data.ComplaintStatus"
                  :disabled="!IsEdit"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in ComplaintStatusArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="投诉类型" prop="ComplaintSubType">
                <el-radio-group v-model="data.ComplaintSubType" :disabled="!IsEdit">
                  <el-radio :label="1">景区投诉</el-radio>
                  <el-radio :label="2">环境投诉</el-radio>
                  <el-radio :label="3">服务投诉</el-radio>
                  <el-radio :label="4">物价投诉</el-radio>
                  <el-radio :label="5">其他投诉</el-radio>
                </el-radio-group>
                <!-- <el-select
                  v-model="data.ComplaintSubType"
                  :disabled="!IsEdit"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in ComplaintSubTypeArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>-->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="投诉内容" prop="Content">
                <el-input
                  v-model="data.Content"
                  :disabled="!IsEdit"
                  type="textarea"
                  :autosize="{ minRows: 2 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="投诉资料">
                <el-upload
                  class="upload-demo"
                  :http-request="httpRequest"
                  :data="uploadData"
                  :show-file-list="true"
                  :file-list="fileList"
                  :before-upload="beforeupload"
                  :on-success="uploadsuccess"
                  :on-progress="uploadProgress"
                  :on-error="uploadError"
                  :on-preview="handlePreview"
                >
                  <el-button size="mini" style="width: 8rem" v-if="IsEdit">上传</el-button>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="data.Extends3!=null && data.Extends3!=''">
            <el-col :span="20" :offset="3">
              <img :src="data.Extends3" style="width: 20rem; height: 20rem" />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="23" :offset="1">
              <el-divider></el-divider>
            </el-col>
          </el-row>

          <el-row style="margin-top: 20px">
            <el-col :span="12">
              <el-form-item label="受理人" prop="AcceptUser">
                <el-input v-model="data.AcceptUser" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="受理时间" prop="AcceptTime">
                <el-date-picker
                  type="datetime"
                  style="width: 100%"
                  placeholder="选择日期"
                  v-model="data.AcceptTime"
                  v-bind:disabled="true"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="处理人" prop="DealUser">
                <el-input v-model="data.DealUser" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="处理时间" prop="DealTime">
                <el-date-picker
                  type="datetime"
                  style="width: 100%"
                  placeholder="选择日期"
                  v-model="data.DealTime"
                  v-bind:disabled="true"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="结案人" prop="FinishUser">
                <el-input v-model="data.FinishUser" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="结案时间" prop="FinishTime">
                <el-date-picker
                  type="datetime"
                  style="width: 100%"
                  placeholder="选择日期"
                  v-model="data.FinishTime"
                  v-bind:disabled="true"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="处理结果" prop="DealResult">
                <el-input
                  v-model="data.DealResult"
                  :disabled="!IsEdit"
                  type="textarea"
                  :autosize="{ minRows: 2 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="不受理原因" prop="NotAcceptReason">
                <el-input
                  v-model="data.NotAcceptReason"
                  :disabled="!IsEdit"
                  type="textarea"
                  :autosize="{ minRows: 2 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="游客反馈" prop="TouristFeedback">
                <el-radio-group v-model="data.TouristFeedback" :disabled="!IsEdit">
                  <el-radio :label="1">非常满意</el-radio>
                  <el-radio :label="2">满意</el-radio>
                  <el-radio :label="3">一般</el-radio>
                  <el-radio :label="4">不满意</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="游客意见" prop="TouristOption">
                <el-input
                  v-model="data.TouristOption"
                  :disabled="!IsEdit"
                  type="textarea"
                  :autosize="{ minRows: 2 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注" prop="Memo">
                <el-input
                  v-model="data.Memo"
                  :disabled="!IsEdit"
                  type="textarea"
                  :autosize="{ minRows: 2 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="结案说明" prop="FinishDesc">
                <el-input
                  v-model="data.FinishDesc"
                  :disabled="!IsEdit"
                  type="textarea"
                  :autosize="{ minRows: 2 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-form-item class="right" style="width: 134rem">
        <el-button @click="onBack()">返回</el-button>
        <el-button type="primary" @click="saveForm()" :disabled="!IsEdit" v-if="IsEdit">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import Apis from "../../../../../../api";
import ZJApp from "../../../../../app";
import permissionsApi from "../../../../../../request/permissionsApi";
import ComplaintApi from "../../../apis/src/ComplaintApi";
const utils = ZJApp.ZJUtils;

export default {
  name: "ComplaintAllInfo",
  controller: "UI",
  action: "ComplaintAllInfo",
  data() {
    return {
      data: {
        TouristFeedback: 0,
        ComplaintTime: new Date()
      },
      ComplaintSource: "",
      ComplaintSourceArr: [
        { value: 6, label: "电话" },
        { value: 7, label: "其他" }
      ],
      ComplaintStatus: "",
      ComplaintStatusArr: [
        { value: 1, label: "待受理" },
        { value: 2, label: "已受理" },
        { value: 3, label: "不受理" },
        { value: 4, label: "已处理" },
        { value: 5, label: "已结案" }
      ],
      ComplaintSubType: "",
      ComplaintSubTypeArr: [
        { value: 1, label: "景区投诉" },
        { value: 2, label: "环境投诉" },
        { value: 3, label: "服务投诉" },
        { value: 4, label: "物价投诉" },
        { value: 5, label: "其他投诉" }
      ],
      ComplaintDepartmentId: "",
      ComplaintDepartments: [],
      loading: false,
      loadingText: "加载中...",
      EqRegionArr: [],
      IsEdit: false,
      uploadData: {
        module: "ComplaintManager", //模块名
        submodule: "", //子模块
        assocID: "", //业务ID
        uploader: ZJApp.ZJUser.current.UserName, //上传人
        folder: "", //上传目录，服务器按如下格式拼装：/{module}/{submodule}/{folder}
        ext1: "", //扩展字段 1
        ext2: "", //扩展字段 2
        ext3: 0 //扩展字段 3
      },
      fileList: [],
      rules: {
        TRASHCODE: [
          { required: true, message: "请输入垃圾桶编号", trigger: "blur" }
        ],
        TRASHNAME: [
          { required: true, message: "请输入垃圾桶名称", trigger: "blur" }
        ],
        LONGITUDE: [
          {
            required: true,
            message: "请输入有效的经度",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/
          }
        ],
        LATITUDE: [
          {
            required: true,
            message: "请输入有效的纬度",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/
          }
        ],
        BELONGAREA: [
          { required: true, message: "请选择区域", trigger: "change" }
        ],
        TRASHTYPE: [
          { required: true, message: "请选择垃圾桶类型", trigger: "change" }
        ]
      },
      uuid:
        this.$route.query.type == "edit"
          ? this.$route.query.InfoId
          : ZJApp.ZJUtils.uuid()
    };
  },
  created: function() {
    this.bindDatabase();
    if (this.$route.query.InfoId) {
      this.getFileList();
    }
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
  },
  mounted: function() {
    if (this.CNF("app.isBiaoZhunHua")) {
      this.getBJDepartments();
    } else {
      this.getTopDepartments();
    }
  },
  watch: {
    $route: function() {
      if (this.$route.query.InfoId) {
        this.getFileList();
      }
    }
  },
  computed: {
    httpRequest() {
      return ZJApp.ZJApis.ZJUploader.upload;
    }
  },
  methods: {
    bindDatabase() {
      this.loading = true;
      this.loadingText = "加载中...";
      return utils
        .waitAll([
          this.config.getUValue("ComplaintSubSystem:ComplaintSource:", ""),
          this.config.getUValue("ComplaintSubSystem:ComplaintStatus:", ""),
          this.config.getUValue("ComplaintSubSystem:ComplaintSubType:", "")
        ])
        .then(r => {
          this.ComplaintSourceArr = r[0].JValue;
          this.ComplaintStatusArr = r[1].JValue;
          this.ComplaintSubTypeArr = r[2].JValue;

          this.loading = false;

          return r;
        })
        .catch(e => {
          console.error(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.loading = false;
        });
    },
    //北京统一登录时获取北京所有部门
    getBJDepartments() {
      console.log(this.$route.query);
      ComplaintApi.GetSuggestDetailForm({
        "id": this.$route.query.Info.id
      }).then(res => {
        console.log(res);
      }).catch(err => {
        console.log(err);
      })
      // permissionsApi
      //   .findOrganizationTree({ projectCode: this.CNF("app.perProjectCode") })
      //   .then(res => {
      //     if (res.code == 0) {
      //       if (res.data.length > 0) {
      //         const departs = this.flattenTree(res.data);

      //         this.ComplaintDepartments = departs.map(item => {
      //           return { OrgId: item.code, OrgName: item.name };
      //         });
      //       }
      //     } else {
      //       this.errmsg(res.msg);
      //     }
      //   });
    },
    flattenTree(nodes) {
      var r = [];
      if (Array.isArray(nodes)) {
        for (var i = 0, l = nodes.length; i < l; i++) {
          r.push(nodes[i]); // 取每项数据放入一个新数组
          if (
            Array.isArray(nodes[i]["children"]) &&
            nodes[i]["children"].length > 0
          )
            // 若存在children则递归调用，把数据拼接到新数组中，并且删除该children
            r = r.concat(this.flattenTree(nodes[i]["children"]));
          delete nodes[i]["children"];
        }
      }
      return r;
    },
    //绑定部门信息
    getTopDepartments() {
      new Apis.OrgApi()
        .FindByConditions({ OrgCode: this.config.app.org_code })
        .then(r => {
          r = r.data.Data;
          if (r != null && r.length > 0) {
            this.getDepartments(r[0].OrgId);
          }
        })
        .catch(e => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    getDepartments(OrgId) {
      new Apis.OrgApi()
        .FindByConditions({ ParentOrgId: OrgId })
        .then(r => {
          r = r.data.Data;
          this.ComplaintDepartments = r;
        })
        .catch(e => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //获取上传附件
    getFileList() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        const searchInfo = { AssocID: InfoId, PageSize: 100, PageIndex: 1 };
        this.data = this.$route.query.Info;
        this.data.ComplaintSource = this.data.ComplaintSource.toString();
        this.loading = true;
        new Apis.FileApi()
          .GetFileList(searchInfo)
          .then(r => {
            r = r.data.Data;
            this.fileList = r.FileList.map(item => ({
              name: item.FileName,
              url: item.DownloadPath + "?d=1"
            }));
            this.loading = false;
          })
          .catch(e => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //保存
    saveForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.saveData();
        } else {
          return false;
        }
      });
    },
    saveData() {
      this.loading = true;
      this.loadingText = "保存中...";
      if (this.$route.query.type == "edit") {
        //编辑
        this.data.ModifyTime = new Date();
        this.data.Modifier = ZJApp.ZJUser.current.UserName;
        let formAll = JSON.stringify(this.data);
        formAll = JSON.parse(formAll);
        new MyApis.TranResourcesApi()
          .UpdateItem(formAll)
          .then(r => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.loading = false;
            this.$router.go(-1); //返回上一层
          })
          .catch(e => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        // 增加
        let formObj = {
          Creater: ZJApp.ZJUser.current.UserName,
          CreateTime: new Date(),
          Modifier: ZJApp.ZJUser.current.UserName,
          ModifyTime: new Date(),
          Id: this.uuid,
          Validity: 1 //新增编辑是1，删除是0
        };
        let formAll = Object.assign(formObj, this.data);
        formAll = JSON.stringify(formAll);
        formAll = JSON.parse(formAll);
        new MyApis.TranResourcesApi()
          .AddItem(formAll)
          .then(r => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.loading = false;
            this.$router.go(-1); //返回上一层
          })
          .catch(e => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    beforeupload: function() {
      this.uploadData.assocID = this.uuid;
      this.loading = true;
      this.loadingText = "上传中... 0%";
    },
    uploadsuccess: function() {
      this.loading = false;
    },
    uploadError(err) {
      console.error("上传失败: ", err);
      this.errmsg("上传失败: " + err);
      this.loading = false;
    },
    uploadProgress(e) {
      this.loadingText = "上传中... " + parseInt(e.percent) + "%";
    },
    handlePreview(file) {
      console.log(file);
      document.location.href = file.url;
    }
  }
};
</script>
